import api from '../constants/roles_api';
import { httpClient } from './httpClient';
import log from './logger/log';
import { dispatch } from '../state/store';
import { addRole, addUser, editRole, editUser, removeRole, setUsers, updateRolesList } from '../state/ducks/roles';

const getRolesAsync = async (filter) => {
    const url = api.GET_ROLE_LIST;

    let postData = {
        pageNumber: filter.pagesFilter.currentPage,
        modelFilter: filter.modelFilter,
        sortFilter: filter.sortFilter
    }
    
    try {
        const data = await httpClient.post(url, postData);
        let roles = {
            items: data.items,
            filter: {
                pagesFilter: { currentPage: data.currentPage, pageCount: data.pagesCount, maxItemsOnPage: data.maxItemsOnPage },
                modelFilter: filter.modelFilter,
                sortFilter: filter.sortFilter
            }
        }
        dispatch(updateRolesList(roles.items, roles.filter));
    }
    catch (error){
        log.error(JSON.stringify(error));
    }
};

const getRoleAsync = async (roleName) => {
    const url = `${api.GET_ROLE}?roleName=${roleName}`;
    
    try{
        const role = await httpClient.get(url);
        return role;
    }
    catch (error) {
        log.error(JSON.stringify(error));
        return null;
    }
}

const updateRoleAsync = async (role) => {
    const url = api.UPDATE_ROLE;

    try{
        const respRole = await httpClient.post(url, role);
        dispatch(editRole(respRole));
    }
    catch(error){
        log.error(`Error occurred during the updating of role. Error: ${JSON.stringify(error)}`);
        throw error;
    }
}

const addRoleAsync = async (role) => {
    const url = api.ADD_ROLE;

    try{
        const responseRole = await httpClient.post(url, role);
        dispatch(addRole(responseRole));
    }
    catch(error){
        log.error(`Error occurred during the adding of role. Error: ${JSON.stringify(error)}`);
        throw error;
    }
}

const deleteRoleAsync = async (roleName) => {
    const url = `${api.DELETE_ROLE}?roleName=${roleName}`;

    try{
        await httpClient.del(url);
        dispatch(removeRole(roleName));
    }
    catch(error){
        log.error(`Error occurred during the removing of role. Error: ${JSON.stringify(error)}`);
        throw error;
    }
}

const roleManagementService = {
    getRolesAsync,
    getRoleAsync,
    updateRoleAsync,
    addRoleAsync,
    deleteRoleAsync
}

export default roleManagementService;